import { Auth } from 'aws-amplify';

/*
  Sign into Amplify Auth. If it's a new user, create it & then login
*/
export async function authAgentOSSignIn(username, userDisplayName, userPassword) {
  try {
    let user = null;
    const cognitoUsername = "OID:" + String(username);

    try {
      // Attempt Sign-in
      user = await Auth.signIn(cognitoUsername, String(userPassword));
    } catch (error) {
      if (error.code === 'UserNotFoundException') {
        // Create user if they don't exist
        try {
          await Auth.signUp({
            username: cognitoUsername,
            password: String(userPassword),
            attributes: {}
          });
          // Sign in after creation
          user = await Auth.signIn(cognitoUsername, String(userPassword));
        } catch (createError) {
          throw createError;
        }
      } else {
        throw error;
      }
    }

    if (user) {
      // Ensure we have valid credentials before proceeding
      try {
        // Force refresh credentials
        await Auth.currentSession();
        const credentials = await Auth.currentCredentials();
        
        if (!credentials.authenticated) {
          throw new Error('Failed to authenticate with AWS');
        }

        // Return the authenticated user info
        return {
          user,
          credentials,
          username: cognitoUsername,
          identityId: credentials.identityId
        };
      } catch (credError) {
        throw credError;
      }
    }

    throw new Error('Failed to authenticate user');
  } catch (error) {
    throw error;
  }
}
/*
  Sign out of Auth
*/
export async function authAgentOSSignOut() {
  try {
      await Auth.signOut();
  } catch (error) {
      console.error('Error signing out:', error)
  }
}